export default __webpack_public_path__ + "static/media/vehicleInspection.e08365ba.png";